
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_18822","data-name":"Group 18822","transform":"translate(-22 -335)"}},[_c('g',{attrs:{"id":"Group_18823","data-name":"Group 18823"}},[_c('rect',{attrs:{"id":"Rectangle_4992","data-name":"Rectangle 4992","width":"22","height":"22","rx":"5","transform":"translate(22 335)","fill":"#f4f5fd"}}),_c('path',{attrs:{"id":"Union_59","data-name":"Union 59","d":"M31.037 353.999a.347.347 0 01-.237-.093.313.313 0 01-.1-.225.332.332 0 01.342-.316h1.616v-1.819l-.17-.018a4.714 4.714 0 01-4.392-4.567v-1.224a.33.33 0 01.337-.316h0a.342.342 0 01.235.091.3.3 0 01.1.223v1.223a4.1 4.1 0 004.225 3.958 4.1 4.1 0 004.22-3.958v-1.217a.338.338 0 01.342-.321.333.333 0 01.342.314v1.223a4.715 4.715 0 01-4.392 4.567l-.17.018v1.819h1.621a.349.349 0 01.238.094.309.309 0 01.1.227.306.306 0 01-.1.223.349.349 0 01-.24.091zm-.979-7.035v-4.174-.184a2.871 2.871 0 012.945-2.67h.1a3.02 3.02 0 012.056.874 2.648 2.648 0 01.793 1.985v4.169a2.918 2.918 0 01-2.945 2.868 2.918 2.918 0 01-2.949-2.868zm.744.528a2.164 2.164 0 001.779 1.667 2.4 2.4 0 00.422.039 2.215 2.215 0 002.2-1.706l.043-.211h-4.489zm2.082-6.919a2.322 2.322 0 00-1.567.7 2.035 2.035 0 00-.58 1.526v3.846h4.535v-3.837-.22a2.067 2.067 0 00-.75-1.472 2.334 2.334 0 00-1.5-.547c-.048 0-.093.002-.138.004z","fill":"#5b6474","stroke":"#5b6474","stroke-miterlimit":"10","stroke-width":".5"}})])])])
          )
        }
      }
    